<template>
  <div class="supply">
    
    <div class="system">
      <div class="big-title">
        <p>行业痛点</p>
        <div class="line"></div>
        <div class="desc">
          直播速度是视频直播所要解决的首要问题，移动+直播+视频是风口也是挑战，只有持续创新，方可解决问题
        </div>
      </div>
      <div class="system-box">
        <div class="system-item" v-for="item in hardArr" :key="item.id" >
          <img :src="item.img" alt="" />
          <h5>{{ item.title }}</h5>
        </div>
      </div>
    </div>
    
    <div class="hard">
      <div class="big-title">
        <p>特色功能</p>
        <div class="line"></div>
        <div class="desc">
          多种特色功能，让在线教学更高效，更安全，更可靠
        </div>
      </div>
      <div class="hard-box">
        <div class="hard-item" v-for="item in systemArr" :key="item.id">
          <img :src="item.img" alt="" />
          <h2>{{ item.title }}</h2>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <div class="videoFrame">
      <div class="big-title">
        <p>运营框架</p>
        <div class="line"></div>
        <div class="desc">
          搭建专属独立网校品牌，提升机构老师运营效率
        </div>
      </div>
        <img src="../../static/images/solution/classVideo5.png" alt="" />
    </div>


    <div class="modeValue">
      <div class="big-title">
        <p>多种应用模式</p>
        <div class="line"></div>
        <div class="desc">
          丰富多彩的应用模式，满足企业平台的不同需求
        </div>
      </div>
      <div class="modeCont">
        <img src="../../static/images/solution/classVideo6.png" alt="" />
        <div class="mode-box">
        <div class="mode-box-after">
          <div v-for="(item,index) in 2" :key="index" >
            <div class="mode-item" >
              <img :src="modeList[index].img" alt="" />
              <div>
                  <h5>{{ modeList[index].title }}</h5>
                  <h6>{{ modeList[index].cont }}</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="mode-box-end">
          <div v-for="(item,index) in 2" :key="index">
            <div class="mode-item" >
              <img :src="modeList[index+2].img" alt="" />
              <div>
                  <h5>{{ modeList[index+2].title }}</h5>
                  <h6>{{ modeList[index+2].cont }}</h6>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //核心列表
      hardArr: [
        {
          id: 0,
          img: require("../../static/images/solution/classVideo11.png"),
          title: "直播平台延迟高\n体验差",
        },
        {
          id: 1,
          img: require("../../static/images/solution/classVideo1.png"),
          title: "无法获取教学数据\n学员反馈",
        },
        {
          id: 2,
          img: require("../../static/images/solution/classVideo2.png"),
          title: "无法监督学生\n不清楚学员效果",
        },
        {
          id: 3,
          img: require("../../static/images/solution/classVideo12.png"),
          title: "教学模式单一\n学员体验不好",
        },
        {
          id: 4,
          img: require("../../static/images/solution/classVideo13.png"),
          title: "招生转化难\n获客成本高",
        },
        {
          id: 5,
          img: require("../../static/images/solution/classVideo14.png"),
          title: "教学视频被\n盗录盗卖",
        },
      ],
      //行业痛点数据
      systemArr: [
        {
          id: 0,
          title:'多种直播类型',
          desc: "支持直播公开课、大班课、小班互动课。形式多样，满足不同类型的直播需求",
          img: require("../../static/images/solution/classVideo15.png"),
        },
        {
          id: 1,
          title:'多种授课模式',
          desc: "支持音视频、各类课件、图文等素材支持桌面分享、软件直播等模式",
          img: require("../../static/images/solution/classVideo16.png"),
        },
        {
          id: 2,
          title:'丰富的课堂功能',
          desc: "支持1v6音视频实时连麦、举手提问答题互动等，让在线课堂更生动",
          img: require("../../static/images/solution/classVideo17.png"),
        },
        {
          id: 3,
          title:'视频安全防护',
          desc: "采用专用加密播放器，直播更安全。智能录屏行为检测，防止盗录；跑马灯水印有效震慑盗录者",
          img: require("../../static/images/solution/classVideo18.png"),
        },
        {
          id: 4,
          title:'稳定可靠',
          desc: "加载快延时低, 抗网络抖动强，直播延时低于200ms,轻松打造企业级在线直播平台",
          img: require("../../static/images/solution/classVideo3.png"),
        },
        {
          id: 5,
          title:'全平台覆盖',
          desc: "支持电PC、Web、iOS、Android等多终端观看，随时随地看观看课程",
          img: require("../../static/images/solution/classVideo4.png"),
        },
      ],
      modeIndex:0,//选中的模式
      //模式列表
      modeList:[
        {
          img:require("../../static/images/solution/classVideo7.png"),
          title:'教育管理者',
          cont:'组织名师开展网络课堂，满足学生、家长课后辅导需求，更大范围共享名师资源。',
        },{
          img:require("../../static/images/solution/classVideo8.png"),
          title:'教师',
          cont:'突破空间限制，提高教学效果；利用丰富的课堂教学工具，制定高效教学计划。',
        },{
          img:require("../../static/images/solution/classVideo9.png"),
          title:'学生',
          cont:'大数据分析学习情况，自主选择课程，实现个性化学习。',
        },{
          img:require("../../static/images/solution/classVideo10.png"),
          title:'家长',
          cont:'减轻家庭经济负担，可陪伴教学，切实了解孩子学习效果。',
        },
      ],
    };
    },
    methods:{
      //立即咨询
    jumpService() {
      this.$addConsult()
    },
  },
};
</script>

<style lang="stylus" scoped>
.supply {
  margin: 80px 0 80px;
}

.hard {
  width: 100%;
  text-align :center
  margin: 0 auto;
  padding-bottom: 80px;
  background: url('../../static/images/solution/tu2.png');

  .big-title{
    p{
      font-size: 30px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 28px;
      margin-top:80px;
    }
    .desc{
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
    }
  }
  .hard-box {
    display: flex;
    margin:0 auto ;
    width :1440px;
    justify-content :space-between
  }
  .hard-item:hover{
    position :relative
    top:-20px
  }
  .hard-item {
    box-sizing: border-box;
    width: 220px;
    height: 310px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      width :58px;
      height :58px;
      margin :48px 0 32px 0
    }
    h2 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }
    p{
      width: 156px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      margin :23px 0 0 0
    }
  }
}
.videoFrame{
  padding:80px 0 0 0
  text-align :center
}

 .modeValue {
  width: 1400px;
  margin: 81px auto;
}

.modeCont{
  position :relative
  display :flex;
  justify-content :center
  margin:27px;
  img{
    width :680px;
    height :490px;
  }
.mode-box {
  position :absolute;
}
.mode-box-end ,.mode-box-after{
    display: flex;
    justify-content :space-between;
    margin :0 auto
}
.mode-box-after{
    margin:49px auto 95px;
    width :1300px;
}
.mode-box-end{
    width :1220px;
}
  .mode-item {
    width: 451px;
    height: 158px;
    padding :28px 40px;
    background: #FFFFFF;
    box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    border-radius: 4px;
    margin-bottom: 24px;
    display: flex;
    justify-content: flex-start;
    img{
      width :40px;
      height :40px
      margin:0 20px 0 0
    }

    p {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      margin-top:40px;
    }
    h5{
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 0 27px 0
    }
    h6{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }
}
.modeItro{
  display :flex;
  justify-content :flex-start;
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin :30px 0 0 0
  span{
    width :70px
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin:0 42px 0 0 
  }
  i{
    list-style :none
    width :543px
  }
}

.system {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 80px;
  border-box:box-sizing ;

  .system-box {
    display: flex;
    flex-wrap: wrap;
    justify-content :space-between
  }
  // .system-item:hover{
  //   background: #FFFFFF;
  //   box-shadow: 0px 5px 17px 3px rgba(133, 131, 123, 0.1);
  //   border-radius: 4px;
  // }
  .system-item {
    width: 233px;
    height: 276px;
    background: #FFFFFF;
    border: 1px solid #F5F5F5;
    border-radius: 4px;
    text-align :center
    img{
      width :62px;
      height :62px
      margin:60px 0 47px 0
    }

    h5{
      width :126px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      margin :0 auto 
    }
  }

  .system-item:hover {
    box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
  }
}

 .line {
    width: 42px;
    height: 2px;
    background: #FFC000;
    border-radius: 1px;
    margin-top: 29px;
  }
.big-title {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
  }

 

  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #333;
    text-align: center;
    margin: 22px 0 50px;
    line-height: 28px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionClassVideo.vue